import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { CalendarEvent } from 'src/app/shared/model/models';
import { ActivityService } from '../activity.service';
import { CalendarEventService } from 'src/app/shared/api/api';
import { VendorConfigService } from '../../config-external-client/services/vendor-config.service';
import { VendorConstant } from '../../../constants/vendor.constant';
import { MessageService } from 'primeng/api';
import { ProfileService } from 'src/app/profile/profileService';

@Component({
    selector: "app-lion-activity-sidebar",
    templateUrl: "./activity-sidebar.component.html",
    styleUrls: ["../shared-activities.component.scss"]
})
export class LionSharedActivitySidebarComponent implements OnInit, OnChanges {
    @Input() objectId = 0;
    @Input() objectType;
    @Input() isViewMode = false;
    @Input() selectedObject;
    @Input() selectedChannel;
    @Output() taskAdded = new EventEmitter<any>();
    @Output() addTaskShow = new EventEmitter<any>();

    filters = {
        ALL_ACTIVITY: 'allactivity',
        EVENTS: 'events',
        TASKS: 'tasks',
        OPEN_TASKS: 'opentasks',
        COMPLETED_TASKS: 'completedtasks'
    };

    objectTypeId = 0;
    activitySidebar = false;
    showCalendar = false;
    editObjectTypeId: number = 0;
    editObjectId: number = 0;

    displayAddTask:boolean = false;
    isAddTask: boolean = false;

    showOverdue: boolean;
    showNoEventTask: boolean;
    isView = true;
    displayEventDetails = false;


    activityOverDue = [];
    today = new Date();
    tomorrow = new Date();
    fromDate = this.today.toISOString();

    currentActivityPage = 1;
    activities = [];
    loadingActivities = true;

    currentNotificationPage = 1;
    totalNotificationPage = 2;
    totalNotifications = 0;
    notifications = [];
    loadingNotifications = true;
    showLoadMoreBtn: boolean = true;

    eventMode = "";
    event: CalendarEvent;

    pageSize = 15;

    filterValue = this.filters.ALL_ACTIVITY;
    usersInCalendar: any;
    isUserCalendar: boolean = false;
    displayConfigExternalClient: boolean = false;
    calendarCategoryId: number;
    initialCalerdarListCount: number;

    constructor(
        public app: AppMainComponent,
        private datePipe: DatePipe,
        private activityService: ActivityService,
        public appMainService: AppMainService,
        private eventService: CalendarEventService,
        private vendorConfigService: VendorConfigService,
        private messageService: MessageService,
        private profileService: ProfileService,
    ) { }

    ngOnInit() {
        if (this.objectType == 'Lead' || this.objectType == 'Account' || this.objectType == 'Opportunity' || this.objectType == 'Cases') {
            if (!this.app.allObjects || this.app.allObjects.length == 0) {
                let object = this.app.preLoadedObjects.map(elem => {
                    return { name: elem.name, id: this.objectId, type: elem.id }
                });
                this.app.allObjects = object;
            }
            this.objectTypeId = this.app.allObjects && this.app.allObjects.length > 0 ? this.app.allObjects.filter(elem => elem.name === this.objectType)[0].type : 0;
        }

        this.tomorrow.setDate(this.tomorrow.getUTCDate() + 1);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes?.objectId?.currentValue) {
            this.objectId = changes?.objectId.currentValue;
        }

        if (changes?.isViewMode?.currentValue) {
			this.isViewMode = changes.isViewMode.currentValue;
		}

        if (changes?.selectedChannel?.currentValue) {
			this.selectedChannel = changes.selectedChannel.currentValue;
		}

        if (changes?.objectType?.currentValue) {
			this.objectType = changes.objectType.currentValue;

            if (this.objectType === 'Case') {
                this.objectType = 'Cases';
            }
		}
    }

    openSidebar() {
        this.activitySidebar = true;
        this.showCalendar = false;
        this.showOverdue = false;
        this.filterValue = this.filters.ALL_ACTIVITY;
        this.getVendorConfig();
        this.filterActivities();
        this.filterNotifications();
    }

    fetchFilteredActivities(filterValue) {
        this.filterValue = filterValue;
        this.filterActivities();
    }

    getDate(date) {
        this.fromDate = date.toISOString();
        this.filterActivities();
    }

    filterNotifications() {
        this.notifications = [];
        this.currentNotificationPage = 1;
        this.fetchSidebarNotifications();
    }

    filterActivities() {
        this.activities = [];
        this.currentActivityPage = 1;
        this.fetchSidebarActivities();
    }

    fetchSidebarActivities() {
        this.loadingActivities = true;
        this.appMainService.isShowSpinner('getSidebarActivities');

        this.activityService.getSidebarActivities(0, 0, this.fromDate, this.filterValue, this.currentActivityPage, this.pageSize)
            .then(res => {
                if (res) {
                    this.activities.push(...res);
                } else {
                    this.showLoadMoreBtn = false;
                }
                this.appMainService.isHideSpinner('getSidebarActivities');
                this.showOverdue = false;
                this.loadingActivities = false;
            })
            .catch(() => {
                this.appMainService.isHideSpinner('getSidebarActivities');
                this.showOverdue = false;
                this.loadingActivities = false;
            });
    }

    fetchSidebarNotifications() {
        this.loadingNotifications = true;
        this.appMainService.isShowSpinner('getSidebarNotifications');

        this.activityService.getSidebarNotifications(0, 0, this.currentNotificationPage, this.pageSize)
            .then(res => {
                this.notifications.push(...res.dataList);
                this.totalNotifications = res.count;
                this.totalNotificationPage = Math.ceil(this.totalNotifications / 15);
                this.appMainService.isHideSpinner('getSidebarNotifications');
                this.loadingNotifications = false;
            })
            .catch(() => {
                this.appMainService.isHideSpinner('getSidebarNotifications');
                this.loadingNotifications = false;
            });
    }

    loadMore() {
        if (this.showOverdue) {
            ++this.currentNotificationPage;
            this.fetchSidebarNotifications();
        } else {
            ++this.currentActivityPage;
            this.fetchSidebarActivities();
        }
    }

    openCreateEventDialog() {
        this.displayEventDetails = true;
        this.eventMode = 'add';
        this.activitySidebar = false;
        this.isUserCalendar = true;
    }

    checkSameDate(d1, d2) {
        return new Date(d1).getUTCFullYear() === new Date(d2).getUTCFullYear() &&
            new Date(d1).getUTCMonth() === new Date(d2).getUTCMonth() &&
            new Date(d1).getUTCDate() === new Date(d2).getUTCDate();
    }

    checkForOverdue(dueDate) {
        const dueDateTime = new Date(dueDate).getTime();
        const currentDateTime = new Date().getTime();

        if (currentDateTime > dueDateTime) {
            return true;
        } else {
            return false;
        }
    }

    checkTaskStatus(s) {
        const dueDateTime = new Date(s.endTime).getTime();
        const currentDateTime = new Date().getTime();

        if (currentDateTime > dueDateTime) {
            switch (s.status) {
                case "open":
                    return "overDueTask"
                case "complete":
                    return "completeTask"
            }
        }
    }

    openActivityDetail(s) {
        this.activitySidebar = false;

        if (s.activityName === "Task") {
            this.app.selectedTaskId =  s.id;
            this.app.displayEditViewTask = true;
        } else if (s.activityName === "CalendarEvent") {
            this.appMainService.isShowSpinner('getEventDetails');

            this.eventService.lionO36020APICalendarEventIdGet(s.id)
                .subscribe((event: CalendarEvent) => {
                    this.appMainService.isHideSpinner('getEventDetails');
                    this.displayEventDetails = true;
                    this.eventMode = "edit";
                    this.event = event;
                    this.editObjectId = s.objectId || 0;
                    this.editObjectTypeId = s.objectTypeId || 0;
                }, () => this.appMainService.isHideSpinner('getEventDetails'));
        }
    }

    cancelEditEvent() {
        this.event = null;
        this.eventMode = "";
        this.displayEventDetails = false;
    }

    completeEditEvent() {
        this.event = null;
        this.eventMode = "";
        this.displayEventDetails = false;
        this.activitySidebar = false;
    }

    openTaskAddDialog() {
        this.displayAddTask = true;
        this.activitySidebar = false;
        this.isAddTask = true;
    }

    createComplete(event) {
        this.displayAddTask = false;
        this.isAddTask = false;
        this.activitySidebar = false;
        this.taskAdded.emit({});
    }

    cancelTaskAdd() {
        this.displayAddTask = false;
        this.isAddTask = false;
    }

    closeDialog() {
        this.displayEventDetails = false;
    }

    getVendorConfig(): void {
        //this.appMainService.isShowSpinner('getVendorConfig');
        this.vendorConfigService.getVendorConfig(VendorConstant.CalendarCategoryId).subscribe(
            {
                next: (response) => {
                    const configList = response || [];
                    const calendarConfig = configList.find((x) => x.name === 'OutlookCalender');
                    this.getCalendarList(calendarConfig?.vendorOAuthRegistration?.id);
                    //this.appMainService.isHideSpinner('getVendorConfig');
                },
                error: (error) => {
                    //this.appMainService.isHideSpinner('getVendorConfig');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.message ? error?.error?.Message : 'Configuration are not loaded, please try again...'
                    });
                },
                complete: () => {

                },
            });
    }

    getCalendarList(oAuthRegistrationId: number): void {
        //this.appMainService.isShowSpinner('getCalendarList');
        this.profileService.getRegisteredCalenderConfig(oAuthRegistrationId).subscribe(
            {
                next: (response) => {
                    const res = response;
                    this.initialCalerdarListCount = res?.length;
                    this.usersInCalendar = this.prepareDataForMenuItems(res) || [];
                    //this.appMainService.isHideSpinner('getCalendarList');
                },
                error: (error) => {
                    //this.appMainService.isHideSpinner('getCalendarList');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.message ? error?.error?.Message : 'Calendar list are not loaded, please try again...'
                    });
                },
                complete: () => {

                },
            });
    }

    prepareDataForMenuItems(originalData): any[]{
        const modifiedData: any[] = originalData.map((obj) => ({
            label: obj?.userMailId,
            id: obj?.id,
            items: [
              {
                label: 'Calendar',
                id: obj?.id
              }
            ]
        }));
        return modifiedData;
    }

    configureEvents(): void {
        this.displayConfigExternalClient = true;
        this.calendarCategoryId = VendorConstant.CalendarCategoryId;

    }

    closeConfigModal(): void {
        this.displayConfigExternalClient = false;
    }

    onCalendarConfigCompleted(): void {
        this.getVendorConfig();
    }
}
